import { Component, OnDestroy, ViewChild } from '@angular/core';

import { NgbDropdown, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import {  Subscription } from 'rxjs';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.scss'],
  imports: [TranslateModule, NgbModule]
})
/**
 * !!! Has to be in app.component.html
 */
export class RightMenuComponent implements OnDestroy {

  @ViewChild('dropDown') dropDown: NgbDropdown;

  watcher: Subscription
  options: any[]
  position = { x: '0', y: '0' }
  
  constructor(protected shared: SharedService) {
    this.watcher = shared.contextMenuOpts.subscribe((pair) => {
     // console.log(window)
      if (this.dropDown) {
        if (pair && pair.options && pair.options.length != 0) {
          this.options = pair.options
          pair.event.preventDefault();
          this.position.x = pair.event.clientX + 'px';
          this.position.y = pair.event.clientY + 'px';
          this.dropDown.open()
        } else {
          this.options = null
          this.dropDown.close()
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.watcher) {
      this.watcher.unsubscribe()
      this.watcher = null
    }
  }

  doClick(opt) {
    if (opt.click)
      opt.click()
  }
}
